import classNames from 'classnames';
import React from 'react';
import { ChevronDownLarge, ChevronLeftLarge, ChevronRightLarge, ChevronUpLarge } from 'wix-ui-icons-common';
import { useFocusedLayout } from '../../../../hooks/focused-layout';
import { IconButton } from '../../../commons/icon-button';
import { useSession } from '../../session-provider';
import { useVideoConfig } from '../../video-config-provider';
import { Tile } from '../tile';
import { ScreenShare } from '../tile/screen-share';
import s from './focused-layout.scss';
import { TileContainer } from './tile-container';
export var FocusedLayout = function (_a) {
    var _b, _c;
    var width = _a.width, height = _a.height;
    var _d = useVideoConfig(), mobile = _d.mobile, sidePanelOpened = _d.sidePanelOpened, recorder = _d.recorder;
    var _e = useSession(), attendees = _e.attendees, currentAttendeeId = _e.currentAttendeeId, sharingAttendeeId = _e.sharingAttendeeId, focusedAttendeeId = _e.focusedAttendeeId;
    var filteredAttendees = recorder ? attendees.filter(function (attendee) { return attendee !== currentAttendeeId; }) : attendees;
    var _f = useFocusedLayout(mobile, width, height, filteredAttendees, focusedAttendeeId), pagesCount = _f.pagesCount, currentPage = _f.currentPage, visibleAttendeeIds = _f.visibleAttendeeIds, setCurrentPage = _f.setCurrentPage;
    var landscape = window.innerWidth > window.innerHeight;
    var isFocused = function (attendeeId) { return !sharingAttendeeId && attendeeId === focusedAttendeeId; };
    var isVisible = function (attendeeId) { return visibleAttendeeIds.includes(attendeeId); };
    var setPreviousPage = function () { return (currentPage === 0 ? setCurrentPage(pagesCount - 1) : setCurrentPage(currentPage - 1)); };
    var setNextPage = function () { return (currentPage + 1 === pagesCount ? setCurrentPage(0) : setCurrentPage(currentPage + 1)); };
    var mobileScreenSharing = Boolean(sharingAttendeeId && mobile);
    var mobileScreenSharingPanelOpened = mobileScreenSharing && sidePanelOpened;
    var mobileScreenSharingLandscape = mobileScreenSharing && landscape;
    var mobileSidePanelOpen = Boolean(mobile && sidePanelOpened);
    var singleTile = filteredAttendees.length === 1 && !sharingAttendeeId;
    var showMainAttendee = !mobileScreenSharingPanelOpened && !mobileScreenSharingLandscape;
    var showAdditionalAttendees = !singleTile && !mobileScreenSharingPanelOpened && !mobileScreenSharingLandscape;
    var mainAttendee = showMainAttendee
        ? filteredAttendees.find(function (id) {
            var focused = isFocused(id);
            return singleTile ? focused || isVisible(id) : focused;
        })
        : null;
    var additionalAttendees = showAdditionalAttendees
        ? filteredAttendees.filter(function (id) { return !isFocused(id) && isVisible(id); })
        : [];
    return (React.createElement("div", { className: classNames(s.container, (_b = {},
            _b[s.mobile] = mobile,
            _b[s.desktop] = !mobile,
            _b[s.singleTile] = singleTile,
            _b[s.mobileScreenSharing] = mobileScreenSharing,
            _b[s.mobileScreenSharingPanelOpened] = mobileScreenSharingPanelOpened,
            _b[s.mobileSidePanelOpen] = mobileSidePanelOpen,
            _b[s.landscape] = landscape,
            _b)) },
        sharingAttendeeId && (React.createElement(TileContainer, { screenShare: true },
            React.createElement(ScreenShare, null))),
        mainAttendee && (React.createElement(AttendeeTile, { key: mainAttendee, attendeeId: mainAttendee, focused: isFocused(mainAttendee), singleTile: singleTile, sharing: sharingAttendeeId === mainAttendee })),
        showAdditionalAttendees && (React.createElement("div", { className: classNames(s.tilesContainer, (_c = {}, _c[s.mobile] = mobile, _c)) }, additionalAttendees.map(function (attendeeId) { return (React.createElement(AttendeeTile, { key: attendeeId, attendeeId: attendeeId, focused: isFocused(attendeeId), singleTile: singleTile, sharing: sharingAttendeeId === attendeeId })); }))),
        pagesCount > 1 && (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { className: s.buttonPrevious, Icon: mobile ? ChevronLeftLarge : ChevronUpLarge, onClick: setPreviousPage }),
            React.createElement(IconButton, { className: s.buttonNext, Icon: mobile ? ChevronRightLarge : ChevronDownLarge, onClick: setNextPage })))));
};
var AttendeeTile = function (_a) {
    var focused = _a.focused, singleTile = _a.singleTile, attendeeId = _a.attendeeId, sharing = _a.sharing;
    return (React.createElement(TileContainer, { focused: focused, singleTile: singleTile, sharing: sharing },
        React.createElement(Tile, { focused: focused, attendeeId: attendeeId })));
};
//# sourceMappingURL=focused-layout.js.map